import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'data-list',
  name: '数据列表',
  icon: '列',
  group: '数据组件',
  description: '展示支持分页、绑定和空态的通用列表',
  defaultProps: {
    layoutMode: 'LIST',
    pageSize: 20,
    emptyText: '暂无数据',
    items: []
  }
}
